<template>
  <div>
    <Top />
    <div class="maindiv zindex-wrap">
      <div class="fmdiv pb40">
        <div class="fs34 tcenter twhite fbold nm">VIP学员报名登录表</div>
        <div class="tbdiv twhite br5 mat bgw tc6">
            <div class="sv prelative dbborder">
              <div class="pabsolute snm fs24 twhite dflex jc-center ai-center">基<br/>本<br/>信<br/>息</div>
              <div class="inputdiv mb20">
                <div class="fl">
                  <label>姓　　名：</label>
                  <input class="input wd175" placeholder="您的姓名" v-model="info.nm" />
                </div>
                <div class="fl lmar96">
                  <label>性别：</label>
                  <select class="input wd90" v-model="info.gender">
                    <option value="1">男</option>
                    <option value="2">女</option>
                  </select>
                </div>
                <div class="fr">
                  <label>出生日期：</label>
                  <input class="input wd175" placeholder="出生年月日" type="date" v-model="info.birthday"/>
                </div>
              </div>
              <div class="inputdiv mb20">
                <div class="fl">
                  <label>身 份 证 ：</label>
                  <input class="input wd175" placeholder="您的身份证号码"  v-model="info.cid"/>
                </div>
                <div class="fl lmar96">
                  <label>学历：</label>
                  专科（
                  <span class="mr10">
                    <input type="radio" value="1" v-model="info.edu">&nbsp;<label>大一</label>
                  </span>
                  <span class="mr10">
                    <input type="radio" value="2" v-model="info.edu">&nbsp;<label>大二</label>
                  </span>
                  <span class="mr10">
                    <input type="radio" value="3" v-model="info.edu">&nbsp;<label>大三</label>
                  </span>）
                </div>
              </div>
              <div class="inputdiv mb20">
                <div class="fl">
                  <label>所属院校：</label>
                  <select class="input wd90" v-model="info.school" style="width: 200px;" @change="info.discipline=''">
                    <option v-for="(item,index) in school_list" :value="index">{{item.name}}</option>
                  </select>
<!--                  <input v-model="info.school" class="input wd280" placeholder="您的学校名称" />-->
                </div>
                <div class="fr">
                  <label>专科专业：</label>
<!--                  <input v-model="info.discipline" class="input wd385" placeholder="您的专业名称"/>-->
                  <select class="input wd90" v-model="info.discipline" style="width: 386px;">
                    <template v-if="info.school">
                      <option v-for="(item,index) in school_list[info.school]['discipline']" :value="index">{{item}}</option>
                    </template>
                    <template v-else>
                      <option value="">请选择所属院校</option>
                    </template>

                  </select>
                </div>
              </div>
              <div class="inputdiv mb20">
                <div class="fl mt5">
                  <span>报考科目：</span>
                  <span class="mr10">
                    <input type="radio" value="1" v-model="info.subject">&nbsp;<label>文科</label>
                  </span>
                  <span class="mr10">
                    <input type="radio" value="2" v-model="info.subject">&nbsp;<label>理科</label>
                  </span>
                </div>
                <div class="fr">
                  <label>目标院校及专业：</label>
                  <input v-model="info.school_dis" class="input wd345" placeholder="您的目标院校及专业名称" />
                </div>
              </div>
              <div class="inputdiv mb20">
                <div class="fl mr40">
                  <label>QQ：</label>
                  <input v-model="info.qq" class="input wd130" placeholder="您的QQ号码" />
                </div>
                <div class="fl mr40">
                  <label>微信：</label>
                  <input v-model="info.weixin" class="input wd130" placeholder="您的微信号" />
                </div>
                <div class="fl mr40">
                  <label>联系方式：</label>
                  <input v-model="info.phone" class="input wd130" placeholder="您的手机号码" />
                </div>
                <div class="fr">
                  <label>联系方式：</label>
                  <input v-model="info.parent_phone" class="input wd130" placeholder="家长手机号码" />
                </div>
              </div>
            </div>

            <div class="sv prelative dbborder">
              <div class="pabsolute snm fs24 twhite dflex jc-center ai-center">学<br/>习<br/>情<br/>况</div>
              <div class="inputdiv mb25">
                <span>学历背景：</span>
                <span class="mr10">
                  <input type="radio" value="1" v-model="info.deu_bg">&nbsp;<label>职高</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="2" v-model="info.deu_bg">&nbsp;<label>普高</label>
                </span>
              </div>
              <div class="inputdiv mb25">
                <span>英语水平：</span>
                <span class="mr10">
                  <input type="radio" value="1" v-model="info.english">&nbsp;<label>未考级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="2" v-model="info.english">&nbsp;<label>B级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="3" v-model="info.english">&nbsp;<label>A级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="4" v-model="info.english">&nbsp;<label>三级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="5" v-model="info.english">&nbsp;<label>四级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="6" v-model="info.english">&nbsp;<label>六级</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="7" v-model="info.english">
                  &nbsp;<label>其他</label>
                  &nbsp;<input v-model="info.english_other" class="input wd130">
                </span>
              </div>
              <div class="inputdiv mb25">
                <span>数学水平：</span>
                <span class="mr10">
                  <input type="radio" value="1" v-model="info.math">&nbsp;<label>未学过高数</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="2" v-model="info.math">&nbsp;<label>学过高数</label>
                </span>
              </div>
              <div class="inputdiv mb25">
                <span>进班时间：</span>
                <span class="mr10">
                  <input type="radio" value="1" v-model="info.enter_dt">&nbsp;<label>尽快安排</label>
                </span>
                <span class="mr10">
                  <input type="radio" value="2" v-model="info.enter_dt">
                  &nbsp;<label>其他</label>
                  &nbsp;<input v-model="info.enter_dt_other" class="input wd130">
                </span>
              </div>
            </div>

            <div class="sv prelative dbborder">
              <div class="pabsolute snm fs24 twhite dflex jc-center ai-center">调<br/>查</div>
              <div class="fbold mb15">了解西培的渠道：</div>
              <div class="inputdiv dflex mb25">
                <span class="dfs0">市场：</span>
                <span class="mr10">
                  <input type="checkbox" value="101" v-model="info.channel">&nbsp;<label>海报</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="102" v-model="info.channel">&nbsp;<label>传单</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="103" v-model="info.channel">&nbsp;<label>讲座</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="104" v-model="info.channel">&nbsp;<label>代理</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="105" v-model="info.channel">&nbsp;<label>外展</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="106" v-model="info.channel">&nbsp;<label>咨询会</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="107" v-model="info.channel">&nbsp;<label>同学推荐</label>
                </span>
              </div>
              <div class="inputdiv dflex mb25">
                <span class="dfs0">网络：</span>
                <span class="mr10">
                  <input type="checkbox" value="201" v-model="info.channel">&nbsp;<label>QQ群</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="202" v-model="info.channel">&nbsp;<label>软文，论坛等</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="203" v-model="info.channel">&nbsp;<label>YY讲座</label>
                </span>
                <span class="mr10">
                  <input type="checkbox" value="204" v-model="info.channel">&nbsp;<label>合作网站推荐</label>
                </span>
              </div>
              <div class="inputdiv mb25 dflex lh20">
                <span class="dfs0">教务：</span>
                <div>
                  <span class="mr10">
                    <input type="checkbox" value="301" v-model="info.channel">&nbsp;<label>任课老师推荐</label>
                  </span>
                  <span class="mr10">
                    <input type="checkbox" value="312" v-model="info.channel">&nbsp;<label>已报名学员推荐</label>
                  </span>
                  <span class="mr10">
                    <input type="checkbox" value="320" v-model="info.channel">&nbsp;<label>班主任推荐渠道拓展</label>
                    <div class="dinline-block">
                      书店（
                      <span class="mr10">
                        <input type="checkbox" value="321" v-model="info.channel">&nbsp;<label>插页</label>
                      </span>
                      <span class="mr10">
                        <input type="checkbox" value="322" v-model="info.channel">&nbsp;<label>海报</label>
                      </span>
                      <span class="mr10">
                        <input type="checkbox" value="323" v-model="info.channel">&nbsp;<label>传单</label>
                      </span>
                      <span class="mr10">
                        <input type="checkbox" value="324" v-model="info.channel">&nbsp;<label>图书</label>
                      </span>
                      <span class="mr10">
                        <input type="checkbox" value="325" v-model="info.channel">&nbsp;<label>条幅</label>
                      </span>）
                    </div>
                    <div class="dinline-block">
                      复印店（
                      <span class="mr10">
                        <input type="checkbox" value="331" v-model="info.channel">&nbsp;<label>广告</label>
                      </span>
                      <span class="mr10">
                        <input type="checkbox" value="332" v-model="info.channel">&nbsp;<label>店主推荐</label>
                      </span>
                      ）
                    </div>
                  </span>
                  <span class="mr10">
                    <label>社区</label>
                    （
                    <input type="checkbox" value="341" v-model="info.channel">&nbsp; <label>海报</label>
                    <input type="checkbox" value="342" v-model="info.channel">&nbsp; <label>传单，伞</label>
                    ）
                  </span>
                </div>
              </div>
              <div class="inputdiv mb25">
                <span>选择西培的原因：</span>
                <input v-model="info.reason" class="input wd760">
              </div>
            </div>

            <div class="sv prelative dbborder fs16">
              <div class="pabsolute snm fs24 twhite dflex jc-center ai-center">报<br/>名<br/>须<br/>知</div>
              <div class="dflex lh20 mt10">
                <span class="dfs0">1. &nbsp;</span>
                <div>若报考院校及专业未确定，请在报考院校和报考专业中写明您的初步意向专业与学校，并注明未定。</div>
              </div>
              <div class="dflex lh20">
                <span class="dfs0">2. &nbsp;</span>
                <div>本人已对西培教育所选项目的报名条件（浙江省各级各类全日制普通高校高职高专应届毕业、遵守宪法和法律、身体健康等）、录取方法、    收费标准和学习方式等内容了解清楚，以上表格内容，信息确认无误。</div>
              </div>
              <div class="dflex lh20 mb10">
                <span class="dfs0">3.&nbsp;</span>
                <div>报名前交定金，如果因自身原因不能来上课，定金一楖不退。</div>
              </div>
            </div>
            <div class="tcenter">
              <a href="javascript:;" class="fs18 zbtn mt35 mb35 hbig trans3 br5" @click="subFrom">确认提交</a>

            </div>

        </div>

      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
  import Top from '../top.vue'
  import Bottom from '../bottom.vue'
  export default {
    name: "index",
    data () {
      return {
        info:{
          channel:[],
          school:0,
          discipline:0,
        },
        data_list:[],
        discipline_list:[],
        school_list:[],
        channel_type_320:0,
        channel_type_330:0,
        channel_type_340:0,
      }
    },
    methods:{
      getInitData(){
        this.$request.get('promotion-apply/enroll-data', {},response => {
          if(response.data.code == 200){
            this.school_list = response.data.data.promotion_school;
          }
        },error => {
          alert('发生错误，请重试');
        })
      },
      subFrom(){
        this.$request.post('promotion-apply/enroll', this.info,response => {
          alert(response.data.message);
          if(response.data.code == 200){

          }
        },error => {
          alert('发生错误，请重试');
        })
      }
    },
    components:{
      Top,
      Bottom,
    },
    created() {
      this.getInitData();
    },
  }
</script>

<style scoped>
 .jc-between{justify-content: space-between;}
 .jc-center{justify-content: center;}
 .ai-center{align-items: center;}
 .fmdiv{background: #929eba;}
 .fmdiv .nm{padding: 70px 0 50px;}
 .tbdiv{padding: 20px 45px 0 30px;width: 1075px;}
 .tbdiv .zbtn{width: 230px;height: 50px;line-height: 50px;background: #929eba;color: #fff;}
 .tbdiv .sv{padding: 20px 20px 20px 100px;}
 .tbdiv .snm{left: 0;top: 20px;bottom: 20px;width: 80px;background-color: #929eba;}
 .input{height: 34px;line-height: 34px;border: 1px solid #d4dadd;background: #f3f3f3;border-radius: 2px;}
 .input:focus{border-color: #3e5693;box-shadow: 0 0 5px #3e5693;}
 .inputdiv::after{content: '';display: block;clear: both;}
 .inputdiv.mb25{margin-bottom: 25px;}
 .input.wd175{width: 175px;}
 .input.wd90{width: 90px;}
 .input.wd280{width: 280px;}
 .input.wd385{width: 385px;}
 .input.wd345{width: 345px;}
 .input.wd130{width: 130px;}
 .input.wd760{width: 760px;}
 .lmar96{margin-left: 96px;}
 .dfs0{flex-shrink: 0;}
</style>



// WEBPACK FOOTER //
// src/components/zedu/index/bm.vue